import React from 'react'
import { useTranslation } from 'react-i18next'

function CareSection() {
  const { t } = useTranslation()
  return (
    <section className="tc-jewelry-care-section py-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="care-content text-center">
              <h3 className="sub-title fsz-45 mb-40 wow fadeInUp slow marcellus" data-wow-delay="0.2s">
                {t('contact.care.title')}
              </h3>
              
              <div className="intro-text mb-60 wow fadeInUp slow" data-wow-delay="0.3s">
                <p className="fsz-20 mb-30 marcellus">
                  {t('contact.care.intro.paragraph1')}
                </p>
                <p className="fsz-18 color-666 marcellus">
                  {t('contact.care.intro.paragraph2')}
                </p>
              </div>

              <div className="care-tips-elegant">
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="care-card wow fadeInUp slow" data-wow-delay="0.2s">
                      <div className="care-number">01</div>
                      <h4 className="care-title marcellus">{t('contact.care.tips.beforeActivities.title')}</h4>
                      <p className="care-description marcellus">
                        {t('contact.care.tips.beforeActivities.description')}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="care-card wow fadeInUp slow" data-wow-delay="0.3s">
                      <div className="care-number">02</div>
                      <h4 className="care-title marcellus">{t('contact.care.tips.chemicalProtection.title')}</h4>
                      <p className="care-description marcellus">
                        {t('contact.care.tips.chemicalProtection.description')}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="care-card wow fadeInUp slow" data-wow-delay="0.4s">
                      <div className="care-number">03</div>
                      <h4 className="care-title marcellus">{t('contact.care.tips.diamondCleaning.title')}</h4>
                      <p className="care-description marcellus">
                        {t('contact.care.tips.diamondCleaning.description')}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="care-card wow fadeInUp slow" data-wow-delay="0.5s">
                      <div className="care-number">04</div>
                      <h4 className="care-title marcellus">{t('contact.care.tips.necklaceCare.title')}</h4>
                      <p className="care-description marcellus">
                        {t('contact.care.tips.necklaceCare.description')}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="care-card wow fadeInUp slow" data-wow-delay="0.6s">
                      <div className="care-number">05</div>
                      <h4 className="care-title marcellus">{t('contact.care.tips.properStorage.title')}</h4>
                      <p className="care-description marcellus">
                        {t('contact.care.tips.properStorage.description')}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="care-card wow fadeInUp slow" data-wow-delay="0.7s">
                      <div className="care-number">06</div>
                      <h4 className="care-title marcellus">{t('contact.care.tips.professionalInspection.title')}</h4>
                      <p className="care-description marcellus">
                        {t('contact.care.tips.professionalInspection.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-cta mt-80 wow fadeInUp slow" data-wow-delay="0.8s">
                <div className="cta-box">
                  <h4 className="fsz-24 mb-20 marcellus">{t('contact.care.cta.title')}</h4>
                  <p className="fsz-16 color-666 mb-30 marcellus">
                    {t('contact.care.cta.description')}
                  </p>
                  <div className="contact-buttons">
                    <a href="mailto:bijouterierj@gmail.com" className="butn hover-bg-brown2 text-capitalize bg-white rounded-pill me-3 marcellus">
                      <span>
                        {t('contact.care.cta.emailButton')}
                        <i className="fal fa-envelope ms-2"></i>
                      </span>
                    </a>
                    <a href="tel:+15142912623" className="butn hover-bg-brown2 text-capitalize bg-white rounded-pill marcellus">
                      <span>
                        {t('contact.care.cta.callButton')}
                        <i className="fal fa-phone ms-2"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative background elements */}
      <div className="care-bg-shapes">
        <div className="shape-1"></div>
        <div className="shape-2"></div>
      </div>
    </section>
  )
}

export default CareSection